import AssignTranscriptPromiseModalView from './AssignTranscriptPromiseModalView'
import React from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AssignTranscriptPromiseModal = (props: any): React.ReactElement => <AssignTranscriptPromiseModalView {...props} />

export default AssignTranscriptPromiseModal
